import React from 'react';

import { RegistrationFormAccessWidget } from '../../../../../auth-management';
import { challengeService } from '../../../../services/challengeService';

type SettingsTabProps = {
  challengeId: number;
};

const getRegistrationLink = async (challengeId: number) => {
  const { registrationLinkUrl } =
    await challengeService.getChallengeRegistrationLink(challengeId);
  return { url: registrationLinkUrl };
};

const getRegistrationQrCode = async (challengeId: number) => {
  const { qrCodeUrl } = await challengeService.getChallengeRegistrationLink(challengeId);
  return { fileUrl: qrCodeUrl };
};

const SettingsTab = ({ challengeId }: SettingsTabProps) => {
  return (
    <RegistrationFormAccessWidget
      id={challengeId}
      getRegistrationLink={getRegistrationLink}
      getRegistrationQrCode={getRegistrationQrCode}
      qrCodeDescription="A QR code has already been generated and assigned to the current challenge"
    />
  );
};

export { SettingsTab };
